@if (status()) {
    <div
        [attr.data-status]="status()"
        [attr.data-on-hold]="isOnHold()"
        class="{{ statusColorMap[status()] }} {{
            sizeMap[size()]
        }} font-semibold flex items-center justify-center gap-2 whitespace-nowrap"
    >
        @if (isOnHold()) {
            <sh-icon data-testid="details-header-icon-on-hold" icon="pause-circle" size="s"></sh-icon>
        }
        {{ 'common.status.' + (isTaskOwner() ? 'internal.' : 'external.') + status() | translate }}
    </div>
}
